import React from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';
import './FontSelector.css';

function ColorPickerSection({ colors, colorConfig, editData, handleInputChange }) {
    
    // Alle Color Items aus den verschachtelten Arrays sammeln
    const allColorItems = colorConfig.flat();
    
    // In 2er-Gruppen aufteilen
    const colorRows = [];
    for (let i = 0; i < allColorItems.length; i += 2) {
        colorRows.push(allColorItems.slice(i, i + 2));
    }

    // Brand Colors aus colors prop extrahieren
    const brandColors = colors && typeof colors === 'object' ? Object.values(colors) : [];

    const handleBrandColorSelect = (colorValue, fieldName) => {
        handleInputChange({ target: { name: fieldName, value: colorValue } });
    };

    
    return (
        <div>
            {colorRows.map((colorRow, rowIndex) => (
                <div key={rowIndex} className="elegant-color-row">
                    {colorRow.map((colorItem, index) => (
                        <div 
                            className="elegant-input-container"
                            key={index}
                        >
                            <div className="elegant-input-header">
                                <label className="elegant-input-label">{colorItem.label}</label>
                                
                                {/* Brand Colors Presets */}
                                {brandColors.length > 0 && (
                                    <div className="brand-colors-presets">
                                        {brandColors.map((brandColor, brandIndex) => (
                                            <button
                                                key={brandIndex}
                                                type="button"
                                                className="brand-color-preset"
                                                style={{ backgroundColor: brandColor }}
                                                onClick={() => handleBrandColorSelect(brandColor, colorItem.fieldName)}
                                                title={`Brand Color ${brandIndex + 1}: ${brandColor}`}
                                            />
                                        ))}
                                    </div>
                                )}
                                
                                <div className="elegant-input-controls">
                                    <div className="elegant-color-picker">
                                        <input 
                                            id={colorItem.fieldName}
                                            type="color" 
                                            name={colorItem.fieldName} 
                                            value={editData[colorItem.fieldName] || colorItem.defaultValue}
                                            onChange={handleInputChange}
                                        />
                                        <div 
                                            className="elegant-color-display" 
                                            style={{ color: editData[colorItem.fieldName] || colorItem.defaultValue }}
                                        >
                                            {colorItem.icon && (
                                                <img 
                                                    className="elegant-color-icon" 
                                                    src={colorItem.icon} 
                                                    alt={colorItem.label} 
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default ColorPickerSection;